import type { ConnectedTypes } from '../../../make-connected';
import type { Types } from '../../../types';
import { min2hrs } from './util';

export function parseMaxWorkingHours (
  group: ConnectedTypes.group | ConnectedTypes.teacher
): Pick<Types.Entities.Group, 'maxNumWorkingHours' | 'maxNumDailyWorkingHours'> | undefined {
  if (!group.maximumScheduleSpan) return;

  return {
    maxNumWorkingHours:      min2hrs(group.maximumScheduleSpan.weekly) ?? false,
    maxNumDailyWorkingHours: min2hrs(group.maximumScheduleSpan.daily ) ?? false,
  };
}
